import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import emailIcon from '../../Assets/Images/emailIcon.png';
import locationPin from '../../Assets/Images/location-pin.png';
import phoneIcon from '../../Assets/Images/phoneIcon.png';
import aboutusImg1 from '../../Assets/Images/aboutusImg1.png'
import { Button, Form } from 'react-bootstrap';
import { FaArrowRightLong } from 'react-icons/fa6';
import { contactUs } from '../../Services/ContactUsServices';
import toast from 'react-hot-toast';
import Loader from '../Main/Loader';

const ContactDetail = () => {


    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [mobileNumber, setMobileNumber] = useState("")
    const [message, setMessage] = useState("")
    const [subject, setSubject] = useState("")
    const [isLoading, setIsLoading] = useState("")

    const hanldeName = (e) => { setName(e.target.value) }
    const hanldeEmail = (e) => { setEmail(e.target.value) }
    const hanldeMobileNumber = (e) => { setMobileNumber(e.target.value) }
    const hanldeMessage = (e) => { setMessage(e.target.value) }
    const hanldeSubject = (e) => { setSubject(e.target.value) }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        let response = await contactUs({ name, email, mobile_number: mobileNumber, subject, message })
        if (response.statusCode === 200) {
            setIsLoading(false)
            toast?.success(response?.message)
            setName("")
            setEmail("")
            setMessage("")
            setMobileNumber("")
            setSubject("")

        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }

    return (
        <Fragment>
            <div className="container py-100 contact-section">
                <div className="row justify-content-between">
                    <div className="col-lg-5">
                        <h2 className='heading'>
                            Contact info
                        </h2>
                        <p>
                            Rennwrites we have teams of professionals ready to assist you. You just have to find the option below that best fits your needs.
                        </p>

                        <div className='bg-light footer rounded-3 p-3'>
                            <ul className='footer'>
                                <li>
                                    <Link to="">
                                        <img className='me-3' src={phoneIcon} alt="" />
                                        +012 345 678 999
                                    </Link>
                                </li>
                                <li>
                                    <Link to="">
                                        <img className='me-3' src={emailIcon} alt="" />

                                        info@rennwrites.com
                                    </Link>
                                </li>
                                <li>
                                    <Link to="">
                                        <img className='me-3' src={locationPin} alt="" />

                                        Office # 123, Lorem ipsum, Dummy address, CA 123456
                                    </Link>
                                </li>
                            </ul>

                        </div>
                    </div>

                    <div className="col-lg-5">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14475.005108148196!2d67.0345444!3d24.90646425!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m3!3e6!4m0!4m0!5e0!3m2!1sen!2s!4v1737644866106!5m2!1sen!2s" width="100%" height="400" style={{ border: "0" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>

                <div className="row mt-5 justify-content-between">
                    <div className="col-lg-6">
                        <img src={aboutusImg1} width={"100%"} alt="" />
                    </div>

                    <div className="col-lg-5">
                        <h2 className='heading'>Contact form</h2>
                        <p>
                            Here you can submit your questions about our company. Need help?
                            You can check your order status and track your delivery easily by logging into My Account.
                        </p>

                        <div>
                            <Form onSubmit={handleSubmit} className='row'>
                                <Form.Group className="col-lg-6 mb-3" controlId="text">
                                    <Form.Control
                                        type="text"
                                        placeholder="First Name"
                                        value={name}
                                        onChange={hanldeName} />
                                </Form.Group>

                                <Form.Group className="col-lg-6 mb-3" controlId="formBasicPassword">
                                    <Form.Control
                                        type="email"
                                        placeholder="Email"
                                        value={email}
                                        onChange={hanldeEmail}
                                    />
                                </Form.Group>

                                <Form.Group className=" mb-3" controlId="formBasicPassword">
                                    <Form.Control
                                        type="number"
                                        placeholder="Enter phone"
                                        value={mobileNumber}
                                        onChange={hanldeMobileNumber}
                                    />
                                </Form.Group>


                                <Form.Group className=" mb-3" controlId="formBasicPassword">
                                    <Form.Control
                                        type="text"
                                        placeholder="Subject"
                                        value={subject}
                                        onChange={hanldeSubject}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        placeholder='Enter Message'
                                        value={message}
                                        onChange={hanldeMessage}
                                    />
                                </Form.Group>
                                <div>
                                    <Button variant="danger" className='s-16 py-2 col-lg-12' type="submit">
                                        {
                                            isLoading ? <Loader /> : (
                                                <>
                                                    Submit < FaArrowRightLong className='ms-2' />
                                                </>
                                            )
                                        }
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </div>

                </div>
            </div>
        </Fragment>
    )
}

export default ContactDetail